var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-loader lds-ring"},[_c('div',{style:(_setup.style)}),_c('div',{style:(_setup.style)}),_c('div',{style:(_setup.style)}),_c('div',{style:(_setup.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }